<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-filter`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 6a2 2 0 012-2h36a2 2 0 012 2v8.321c.03.19.029.383 0 .57V15a.998.998 0 01-.397.798 1.893 1.893 0 01-.508.441L32 22.862V43a1 1 0 01-1 1h-2a1 1 0 01-1-1V22a2 2 0 01.086-.583c.12-.47.419-.893.867-1.161L40 13.662V8H8v5.732l10.69 6.39A2 2 0 0120 22v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V22.93L4.923 16.308a1.888 1.888 0 01-.608-.58A.997.997 0 014 15V6z"/></svg>
</template>
<script>

export default {
  name: 'IconFilter',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
